var widgetUrlServices = {
  async getFunnelWidgetUrl ({ clinicWidgetId, baseUrl }) {
    return `${baseUrl}?provider=${clinicWidgetId}`
  },
}

export default widgetUrlServices
